"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListTable = _interopRequireDefault(require("01_core/components/layout/module/ListTable"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CCheckBox = _interopRequireDefault(require("01_core/components/materials/CCheckBox"));
var _CDialog = _interopRequireDefault(require("01_core/components/materials/CDialog"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CheckBoxHeader = _interopRequireDefault(require("01_core/components/materials/CheckBoxHeader"));
var _DocumentLink = _interopRequireDefault(require("01_core/components/select/DocumentLink"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _kansaAnswerActions = require("../kansaAnswerActions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HEADER_MARGIN_LEFT = 18;
const CHECKBOX_MARGIN_LEFT = 4;
const BUTTON_MARGIN_LEFT = 15;
const StyledCheckBoxHeader = (0, _styles.styled)(_CheckBoxHeader.default)(() => ({
  marginLeft: HEADER_MARGIN_LEFT
}));
const StyledCCheckBox = (0, _styles.styled)(_CCheckBox.default)(() => ({
  marginLeft: CHECKBOX_MARGIN_LEFT
}));
const StyledCButtonMargin = (0, _styles.styled)(_CButton.default)(() => ({
  marginLeft: BUTTON_MARGIN_LEFT
}));

/**
 * BCP証跡登録部品
 * @prop {string} [gyomuCd] - 選択されている業務内容（1:監査部門／2:被監査部門）
 * @prop {string} [kansaTgtNendo] - 選択されている監査対象年度
 * @prop {string} [kansaTgtJigyoId] - 選択されている監査対象事業ID
 * @prop {func} onChange - 変更ハンドラ<br/>
 */
const KansaAnswerBcpTrailEntry = props => {
  const {
    intl,
    gyomuCd,
    kansaTgtNendo,
    kansaTgtJigyoId,
    paging,
    searchBcpTrailResult,
    bcpListState,
    changeEviStatus,
    changeEviStatusAll,
    allRegFlg,
    setSearchBcpTrailResult,
    openInfoBar,
    callAPI,
    clearDirty,
    onChange
  } = props;
  const [isDialogOpen, setIsDialogOpen] = (0, _react.useState)(false);

  /** 監査BCP証跡情報検索処理 */
  const searchBcpTrailData = (0, _react.useCallback)(() => {
    callAPI(_APIs.KANSA_ANSWER_BCP_TRAIL_SEARCH, {
      searchContent: gyomuCd,
      kansaTgtNendo,
      kansaTgtJigyoId
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setSearchBcpTrailResult(response.data);
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    });
  }, [callAPI, gyomuCd, kansaTgtNendo, kansaTgtJigyoId, setSearchBcpTrailResult, openInfoBar]);

  /** ダイアログを開くイベント */
  const openDialog = (0, _react.useCallback)(() => {
    setIsDialogOpen(true);
    searchBcpTrailData();
  }, [searchBcpTrailData]);

  /** ダイアログを閉じるイベント */
  const closeDialog = (0, _react.useCallback)(() => {
    setIsDialogOpen(false);
  }, []);

  /** 登録処理 */
  const updateSetting = (0, _react.useCallback)(updateData => {
    callAPI(_APIs.KANSA_ANSWER_BCP_TRAIL_REGIST, {
      items: updateData,
      kansaTgtNendo,
      kansaTgtJigyoId
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        onChange();
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
      clearDirty();
      closeDialog();
    });
  }, [callAPI, kansaTgtNendo, kansaTgtJigyoId, onChange, openInfoBar, clearDirty, closeDialog]);

  /** 登録ボタン押下イベント */
  const onUpdate = (0, _react.useCallback)(() => {
    // 更新データの作成
    const updateData = [];
    for (let key in bcpListState) {
      if (bcpListState[key].isChange && !bcpListState[key].eviStatusOrg) {
        updateData.push({
          documentKindNm: bcpListState[key].documentKindNm,
          fileNm: bcpListState[key].fileNm,
          siteKindCd: bcpListState[key].siteKindCd,
          targetCd: bcpListState[key].targetCd,
          bcmKaishaSoshikiCd: bcpListState[key].bcmKaishaSoshikiCd,
          bcpTgtJigyoCd: bcpListState[key].bcpTgtJigyoCd,
          bcpTgtJigyoNm: bcpListState[key].bcpTgtJigyoNm,
          documentKindCd: bcpListState[key].documentKindCd,
          versionCnt: bcpListState[key].versionCnt
        });
      }
    }
    if (updateData.length !== 0) {
      updateSetting(updateData);
    } else {
      openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_PLEASE_SELECT_REPLACE
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_FILE
        })
      }));
    }
  }, [bcpListState, updateSetting, openInfoBar, intl]);
  const getId = (0, _react.useCallback)(data => data.bcmKaishaSoshikiCd + data.soshikiNmFull + data.bcpTgtJigyoCd + data.documentKindNm, []);

  // 検索結果ヘッダ（証跡情報）
  const columns = (0, _react.useMemo)(() => [{
    dataKey: 'bcmKaishaSoshikiRk',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI
    }),
    width: 180,
    minWidth: 50
  }, {
    dataKey: 'soshikiNmFull',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TARGET
    }) + intl.formatMessage({
      id: _labelConsts.LABEL.CORE_ORGANIZATION
    }),
    width: 180,
    minWidth: 50
  }, {
    dataKey: 'bcpTgtJigyoNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_BCP_TARGET_BUSINESS
    }),
    width: 180,
    minWidth: 50
  }, {
    dataKey: 'documentKindNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_DOCUMENT_NM
    }),
    width: 180,
    minWidth: 50
  }, {
    dataKey: 'fileNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_FILE
    }),
    width: 180,
    minWidth: 50
  }, {
    dataKey: 'eviStatus',
    label: /*#__PURE__*/_react.default.createElement(StyledCheckBoxHeader, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_REGISTER
      }),
      list: searchBcpTrailResult,
      paging,
      getId,
      checkLogic: state => state.eviStatus,
      checkedList: bcpListState,
      changeCheckedAll: changeEviStatusAll
    }),
    width: 70,
    minWidth: 50,
    maxWidth: 70
  }], [intl, searchBcpTrailResult, paging, getId, bcpListState, changeEviStatusAll]);

  // 検索結果ボディ
  const createRow = (0, _react.useCallback)(data => {
    const bcmKaishaSoshikiRk = _stringUtil.default.emptyToHyphen(data.bcmKaishaSoshikiRk);
    const soshikiNmFull = _stringUtil.default.emptyToHyphen(data.soshikiNmFull);
    const bcpTgtJigyoNm = _stringUtil.default.emptyToHyphen(data.bcpTgtJigyoNm);
    const documentKindNm = _stringUtil.default.emptyToHyphen(data.documentKindNm);
    const fileNm = data.fileNm ? /*#__PURE__*/_react.default.createElement(_DocumentLink.default, {
      dispFileNm: data.fileNm,
      fileNm: data.fileNm,
      siteKindCd: data.siteKindCd,
      targetCd: data.targetCd,
      bcmKaishaSoshikiCd: data.bcmKaishaSoshikiCd,
      bcpTgtJigyoCd: data.bcpTgtJigyoCd,
      documentKindCd: data.documentKindCd
    }) : _stringUtil.default.emptyToHyphen(data.fileNm);
    const eviStatus = bcpListState[getId(data)].eviStatusOrg ? intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_INSERTED
    }) : /*#__PURE__*/_react.default.createElement(StyledCCheckBox, {
      color: "secondary",
      checked: bcpListState[getId(data)].eviStatus,
      onChange: value => {
        changeEviStatus(getId(data), value);
      }
    });
    return {
      bcmKaishaSoshikiRk,
      soshikiNmFull,
      bcpTgtJigyoNm,
      documentKindNm,
      fileNm,
      eviStatus
    };
  }, [bcpListState, changeEviStatus, getId, intl]);
  const cancelBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    negative: true,
    onClick: closeDialog
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CANCEL
  }));
  const registBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    onClick: onUpdate
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledCButtonMargin, {
    autoWidth: true,
    onClick: openDialog
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_BCP_DEVELOPMENT_OF_TRAIL_ADDED
  })), /*#__PURE__*/_react.default.createElement(_CDialog.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_BCP_DEVELOPMENT_TRAIL_ADDED
    }),
    actions: [cancelBtn, !allRegFlg && registBtn],
    open: isDialogOpen,
    handleClose: closeDialog
  }, /*#__PURE__*/_react.default.createElement(_material.DialogContent, null, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, searchBcpTrailResult.length === 0 ? /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_NOTFOUND_CONFIRM_TRAIL_MESSAGE
  })) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_BCP_TERGET_SELECT
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_ListTable.default, {
    rowData: searchBcpTrailResult,
    autoWidth: true,
    headerHeight: 45,
    columns,
    createRow
  }))))));
};
KansaAnswerBcpTrailEntry.propTypes = {
  required: _propTypes.default.bool,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired
};
const mapStateToProps = state => {
  return {
    systemSettings: state.coreLoginInfo.systemSettings,
    searchBcpTrailResult: state.kansaAnswer.searchBcpTrailResult,
    bcpListState: state.kansaAnswer.bcpListState,
    paging: state.kansaAnswer.paging,
    allRegFlg: state.kansaAnswer.allRegFlg
  };
};
const mapDispatchToProps = dispatch => ({
  setSearchBcpTrailResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_SEARCH_BCP_TRAIL_RESULT](resultList)),
  openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
  changeEviStatus: (key, eviStatus) => {
    dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
    dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_EVI_STATUS](key, eviStatus));
  },
  changeEviStatusAll: eviStatus => {
    dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
    dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.CHANGE_EVI_STATUS_ALL](eviStatus));
  },
  clearDirty: () => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](false))
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaAnswerBcpTrailEntry)));